import {
  TXTCLI_Or,
  TXTCLI_Retry,
  TXTCLI_Select,
  TXTCLI_Smile,
  TXTCLI_Start__process,
  TXTWCL_Accepted_formatsX_JPGX_PNGX_PD_ELL,
  TXTWCL_Action_timed_out,
  TXTWCL_AlsoX_double_check_the_documen_ELL,
  TXTWCL_Back_View,
  TXTWCL_Bad_2,
  TXTWCL_Blur_detected,
  TXTWCL_Blurry,
  TXTWCL_Check_the_preview_of_your_Iden_ELL,
  TXTWCL_Click_on_Start_Auto_Capture_to_ELL,
  TXTWCL_Close_5,
  TXTWCL_Document_Too_Far,
  TXTWCL_Document_must_not_be_coveredX,
  TXTWCL_Document_not_in_frame,
  TXTWCL_Drag_and_Drop,
  TXTWCL_Examples_of_good_and_bad_photo_ELL,
  TXTWCL_Face_must_not_be_coveredX,
  TXTWCL_Failed,
  TXTWCL_File_sizeX_we_accept_any_file__ELL,
  TXTWCL_Fit_the_document_fully_within__ELL,
  TXTWCL_Front_View,
  TXTWCL_Frown,
  TXTWCL_Good_6,
  TXTWCL_Hold_the_document_or_device_st_ELL,
  TXTWCL_How_to_take_a_photo_of_your_Id_ELL,
  TXTWCL_How_to_take_a_selfie,
  TXTWCL_Identity_Document_1,
  TXTWCL_Initializing_Smart_CaptureX_pl_ELL,
  TXTWCL_Interrupted,
  TXTWCL_Look_directly_into_the_camera__ELL,
  TXTWCL_Look_down,
  TXTWCL_Look_left,
  TXTWCL_Look_right,
  TXTWCL_Look_straight_ahead,
  TXTWCL_Look_up,
  TXTWCL_Move_the_document_away_from_di_ELL,
  TXTWCL_Need_helpX_3,
  TXTWCL_No_action,
  TXTWCL_Passed,
  TXTWCL_Photo_is_clearX_in_focusX_and__ELL,
  TXTWCL_Photo_must_not_be_blurryX,
  TXTWCL_Photo_must_show_all_four_corne_ELL,
  TXTWCL_Please_check_that_the_preview__ELL,
  TXTWCL_Please_make_sure_you_can_see_a_ELL,
  TXTWCL_Please_upload_a_photo_of_your__ELL_1,
  TXTWCL_Position_the_BACK_of_your_Iden_ELL,
  TXTWCL_Position_the_photo_side_of_you_ELL,
  TXTWCL_Position_your_Proof_of_Address_ELL,
  TXTWCL_Position_your_face_within_the__ELL,
  TXTWCL_Prevent_Glare,
  TXTWCL_Proof_of_Address,
  TXTWCL_Selfie_is_clearX_in_focusX_and_ELL,
  TXTWCL_Selfie_must_not_be_blurryX,
  TXTWCL_Selfie_must_show_the_full_face_ELL,
  TXTWCL_Something_isnXt_quite_rightX_b_ELL,
  TXTWCL_Start_Auto_Capture,
  TXTWCL_Take_a_photo_instead,
  TXTWCL_Tips_for_a_good_quality_selfie_ELL,
  TXTWCL_Tips_for_taking_a_good_quality_ELL,
  TXTWCL_Uh_OhXXWe_are_unable_to_detect_ELL,
  TXTWCL_Uh_OhXX_Something_went_wrongX__ELL,
  TXTWCL_Uh_OhXX_We_are_unable_to_detec_ELL,
  TXTWCL_Uh_OhXX_You_are_too_closeX_ple_ELL,
  TXTWCL_Uh_OhXX_You_are_too_far_awayX__ELL,
  TXTWCL_Undefined,
  TXTWCL_Upload_1,
  TXTWCL_Upload_a_photo_instead,
  TXTWCL_Upload_a_photo_of_your_Identit_ELL,
  TXTWCL_UploadingXX,
  TXTWCL_When_Auto_Capture_is_onX_the_c_ELL
} from './dictionary.messages.json';

const dictionary = {
  PREVIEW_ATTEMPT_NUMBER_START: `${TXTWCL_Something_isnXt_quite_rightX_b_ELL.defaultMessage} 
    ${TXTWCL_Please_make_sure_you_can_see_a_ELL.defaultMessage} ${TXTWCL_AlsoX_double_check_the_documen_ELL.defaultMessage}`,
  PREVIEW_ATTEMPT_NUMBER_END: ``,
  PASSIVE_LIVENESS_ERROR_FACE_NOT_FOUND_TITLE:
    TXTWCL_Uh_OhXXWe_are_unable_to_detect_ELL.defaultMessage,
  PREVIEW_INFO_TITLE_FACEMATCH: TXTWCL_Tips_for_a_good_quality_selfie_ELL.defaultMessage,
  HELP_MODAL_SELFIE_SUBTITLE: TXTWCL_Look_directly_into_the_camera__ELL.defaultMessage,
  HELP_MODAL_SELFIE_TITLE: TXTWCL_How_to_take_a_selfie.defaultMessage,
  PREVIEW_INFO_BAD_EXAMPLE_BLUR_FACEMATCH: TXTWCL_Selfie_must_not_be_blurryX.defaultMessage,
  PREVIEW_INFO_BAD_EXAMPLE_COVER_FACEMATCH: TXTWCL_Face_must_not_be_coveredX.defaultMessage,
  PREVIEW_INFO_BAD_EXAMPLE_ANGLE_FACEMATCH:
    TXTWCL_Selfie_must_show_the_full_face_ELL.defaultMessage,
  PREVIEW_INFO_GOOD_EXAMPLE_FACEMATCH: TXTWCL_Selfie_is_clearX_in_focusX_and_ELL.defaultMessage,
  CAMERA_CAPTURE_ADDRESS_CAPTION: TXTWCL_Position_your_Proof_of_Address_ELL.defaultMessage,
  CAMERA_CAPTURE_BACK: TXTWCL_Position_the_BACK_of_your_Iden_ELL.defaultMessage,
  CAMERA_CAPTURE_SELFIE_CAPTION: TXTWCL_Position_your_face_within_the__ELL.defaultMessage,
  CAMERA_CAPTURE_START_BUTTON: TXTWCL_Start_Auto_Capture.defaultMessage,
  CAMERA_CAPTURE_CAPTION: TXTWCL_Click_on_Start_Auto_Capture_to_ELL.defaultMessage,
  CAMERA_CONDITION_BLUR: TXTWCL_Blur_detected.defaultMessage,
  CAMERA_PREVENT_LOW_RES_HINT: TXTWCL_Fit_the_document_fully_within__ELL.defaultMessage,
  CAMERA_CONDITION_ALIGNMENT: TXTWCL_Document_not_in_frame.defaultMessage,
  CAMERA_CAPTURE_FRONT: TXTWCL_Position_the_photo_side_of_you_ELL.defaultMessage,
  FILESYSTEM_ADDRESS: TXTWCL_Proof_of_Address.defaultMessage,
  FILESYSTEM_CHOOSE: TXTCLI_Select.defaultMessage,
  HELP_MODAL_POA_BLUR_TITLE: TXTWCL_Blurry.defaultMessage,

  REQUIRED_ACTION_Close: TXTWCL_Close_5.defaultMessage,
  HELP_MODAL_NEED_HELP: TXTWCL_Need_helpX_3.defaultMessage,
  HELP_MODAL_AUTOCAPTURE_BLUR_SUBTITLE: TXTWCL_Hold_the_document_or_device_st_ELL.defaultMessage,
  HELP_MODAL_AUTOCAPTURE_FAR_SUBTITLE: TXTWCL_Fit_the_document_fully_within__ELL.defaultMessage,
  HELP_MODAL_AUTOCAPTURE_FAR_TITLE: TXTWCL_Document_Too_Far.defaultMessage,
  HELP_MODAL_AUTOCAPTURE_GLARE_TITLE: TXTWCL_Prevent_Glare.defaultMessage,
  HELP_MODAL_AUTOCAPTURE_GLARE_SUBTITLE: TXTWCL_Move_the_document_away_from_di_ELL.defaultMessage,
  HELP_MODAL_AUTOCAPTURE_TIPS: TXTWCL_Tips_for_taking_a_good_quality_ELL.defaultMessage,
  HELP_MODAL_AUTOCAPTURE_SUBTITLE: TXTWCL_When_Auto_Capture_is_onX_the_c_ELL.defaultMessage,
  HELP_MODAL_AUTOCAPTURE_TITLE: TXTWCL_How_to_take_a_photo_of_your_Id_ELL.defaultMessage,
  MANUAL_PHOTO_UPLOAD_TOGGLE_TRUE: TXTWCL_Take_a_photo_instead.defaultMessage,
  MANUAL_PHOTO_UPLOAD_TOGGLE_FALSE: TXTWCL_Upload_a_photo_instead.defaultMessage,
  PROVIDER_SUBTITLE_VIEW_ID: TXTWCL_Please_check_that_the_preview__ELL.defaultMessage,
  PROVIDER_TITLE_VIEW_ID: TXTWCL_Check_the_preview_of_your_Iden_ELL.defaultMessage,
  PROVIDER_TITLE_FILESYSTEM_ADDRESS: TXTWCL_Proof_of_Address.defaultMessage,
  FILESYSTEM_IDENTITY_DOCUMENT: TXTWCL_Identity_Document_1.defaultMessage,
  PREVIEW_INFO_GOOD: TXTWCL_Good_6.defaultMessage,
  PREVIEW_INFO_BAD: TXTWCL_Bad_2.defaultMessage,
  PREVIEW_INFO_BAD_EXAMPLE_BLUR_ID: TXTWCL_Photo_must_not_be_blurryX.defaultMessage,
  PREVIEW_INFO_BAD_EXAMPLE_COVER_ID: TXTWCL_Document_must_not_be_coveredX.defaultMessage,
  PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ID: TXTWCL_Photo_must_show_all_four_corne_ELL.defaultMessage,
  PREVIEW_INFO_GOOD_EXAMPLE_ID: TXTWCL_Photo_is_clearX_in_focusX_and__ELL.defaultMessage,
  FILESYSTEM_OR: TXTCLI_Or.defaultMessage,
  FILESYSTEM_DRAG_DROP: TXTWCL_Drag_and_Drop.defaultMessage,
  FILESYSTEM_MAX_FILE_SIZE: TXTWCL_File_sizeX_we_accept_any_file__ELL.defaultMessage,
  FILESYSTEM_SUPPORTED_TYPES_END: '',
  FILESYSTEM_SUPPORTED_TYPES_START: TXTWCL_Accepted_formatsX_JPGX_PNGX_PD_ELL.defaultMessage,
  'FLOW_STATE_IDENTITY:FRONT': TXTWCL_Front_View.defaultMessage,
  'FLOW_STATE_IDENTITY:BACK': TXTWCL_Back_View.defaultMessage,
  PROVIDER_TITLE_FILESYSTEM_ID: TXTWCL_Upload_a_photo_of_your_Identit_ELL.defaultMessage,
  PROVIDER_SUBTITLE_FILESYSTEM_ID: TXTWCL_Please_upload_a_photo_of_your__ELL_1.defaultMessage,
  PREVIEW_INFO_TITLE_ID: TXTWCL_Examples_of_good_and_bad_photo_ELL.defaultMessage,
  VIEW_UPLOAD: TXTWCL_Upload_1.defaultMessage,
  VIEW_RETRY: TXTCLI_Retry.defaultMessage,
  SMART_CAPTURE_START: TXTCLI_Start__process.defaultMessage,
  SMART_CAPTURE_INITIALIZING: TXTWCL_Initializing_Smart_CaptureX_pl_ELL.defaultMessage,
  VIEW_UPLOADING: TXTWCL_UploadingXX.defaultMessage,
  CROPPER_UPLOADING: TXTWCL_UploadingXX.defaultMessage,

  LIVENESS_ACTION_Smile: TXTCLI_Smile.defaultMessage,
  LIVENESS_ACTION_Frown: TXTWCL_Frown.defaultMessage,
  'LIVENESS_ACTION_Tilt Left': TXTWCL_Look_left.defaultMessage,
  'LIVENESS_ACTION_Tilt Right': TXTWCL_Look_right.defaultMessage,
  'LIVENESS_ACTION_Tilt Up': TXTWCL_Look_up.defaultMessage,
  'LIVENESS_ACTION_Tilt Down': TXTWCL_Look_down.defaultMessage,
  'LIVENESS_ACTION_Look Straight': TXTWCL_Look_straight_ahead.defaultMessage,
  'LIVENESS_ACTION_No Action': TXTWCL_No_action.defaultMessage,
  'LIVENESS_RESULT_Thank you!.Failed': TXTWCL_Failed.defaultMessage,
  'LIVENESS_RESULT_Thank you!.Passed': TXTWCL_Passed.defaultMessage,
  'LIVENESS_RESULT_Thank you!.ActionTimedOut': TXTWCL_Action_timed_out.defaultMessage,
  'LIVENESS_RESULT_Thank you!.Interrupted': TXTWCL_Interrupted.defaultMessage,
  'LIVENESS_RESULT_Thank you!.Undefined': TXTWCL_Undefined.defaultMessage,
  PASSIVE_LIVENESS_ERROR_FACE_TOO_CLOSE: TXTWCL_Uh_OhXX_You_are_too_closeX_ple_ELL.defaultMessage,
  PASSIVE_LIVENESS_ERROR_FACE_CLOSE_TO_BORDER:
    TXTWCL_Uh_OhXX_You_are_too_closeX_ple_ELL.defaultMessage,
  PASSIVE_LIVENESS_ERROR_FACE_CROPPED: TXTWCL_Uh_OhXX_Something_went_wrongX__ELL.defaultMessage,
  PASSIVE_LIVENESS_ERROR_FACE_NOT_FOUND: TXTWCL_Uh_OhXX_We_are_unable_to_detec_ELL.defaultMessage,
  PASSIVE_LIVENESS_ERROR_FACE_TOO_SMALL: TXTWCL_Uh_OhXX_You_are_too_far_awayX__ELL.defaultMessage,
  PASSIVE_LIVENESS_ERROR_FACE_ANGLE_TOO_LARGE:
    TXTWCL_Uh_OhXX_Something_went_wrongX__ELL.defaultMessage,
  PASSIVE_LIVENESS_ERROR_TOO_MANY_FACES: TXTWCL_Uh_OhXX_We_are_unable_to_detec_ELL.defaultMessage,
  PASSIVE_LIVENESS_ERROR_UNKNOWN: TXTWCL_Uh_OhXX_Something_went_wrongX__ELL.defaultMessage,
  PASSIVE_LIVENESS_ERROR_INTERNAL: TXTWCL_Uh_OhXX_Something_went_wrongX__ELL.defaultMessage,
  PREVIEW_INFO_GOOD_EXAMPLE_ADDRESS: TXTWCL_Photo_is_clearX_in_focusX_and__ELL.defaultMessage,
  PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ADDRESS: TXTWCL_Selfie_must_show_the_full_face_ELL.defaultMessage,
  PREVIEW_INFO_BAD_EXAMPLE_BLUR_ADDRESS: TXTWCL_Selfie_must_not_be_blurryX.defaultMessage,
  PREVIEW_INFO_BAD_EXAMPLE_COVER_ADDRESS: TXTWCL_Document_must_not_be_coveredX.defaultMessage
};

export default dictionary;
